import { useAxios } from "@hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  AssignAssessorsRequest,
  AssignAssessorsResult,
} from "../../types/grading/PendingCorrection";

/**
 * Assigns one or more assessors to grade an exam term or a single exam instance.
 */
export const useAssignAssessors = () => {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation<AssignAssessorsResult, Error, AssignAssessorsRequest>({
    mutationFn: async (request: AssignAssessorsRequest) => {
      const response = await axios.post<AssignAssessorsResult>(
        `/api/grading/assignments`,
        request
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["pendingCorrections"] });
      queryClient.invalidateQueries({ queryKey: ["gradingAssignments"] });
    },
  });
};

export default useAssignAssessors;
